<template>
  <div>
    <v-container>
      <v-btn @click="back" text class="text_btn">
        <v-icon>keyboard_arrow_left</v-icon>back
      </v-btn>
      <h1>Third-Party API keys ({{ p_name }})</h1>
      <br />
      <v-layout wrap row>
        <v-flex sm3 xs12>
          <v-list style="background:transparent;" shaped>
            <v-list-item-group mandatory="true" v-model="nav_service" color="primary">
              <v-list-item
                v-for="available_service in available_services"
                :key="available_service.value"
              >
                <!--<v-list-item-icon>
                    <v-icon>storage</v-icon>
                </v-list-item-icon>-->
                <v-list-item-content>
                  <v-list-item-title>{{ available_service.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-flex>
        <v-flex xs12 sm9>
          <section v-for="available_service in available_services" :key="available_service.value">
            <h2>{{ available_service.text }}</h2>
            <p>{{ available_service.description }}</p>
            <p>
              <a :href="available_service.website" target="_blank">
                <i class="fal fa-globe"></i>
              </a>
              <a style="margin-left: 20px;" :href="available_service.website_docs" target="_blank">
                <i class="fal fa-book"></i>
              </a>
            </p>
            <v-form @submit="saveAPIKey">
              <v-text-field
                :disabled="!l_keys"
                :loading="!l_keys"
                label="API-Key"
                v-model="available_service.api_key"
              ></v-text-field>
              <v-btn type="submit">
                <v-icon>save</v-icon>save
              </v-btn>
            </v-form>
          </section>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ThirdPartyKeys from "../../logic/ThirdPartyKeys";
import { Projects } from "../../logic/Projects";
import { Notifications } from "../../notification";

export default {
  data() {
    return {
      p_name: "...",
      project_id: null,

      available_services: ThirdPartyKeys.available_services,

      nav_service: 0,
      keys: [],

      l_keys: false,
    };
  },
  mounted() {
    this.setTitle("Third-Party API Keys");
    this.project_id = parseInt(this.$route.params.project_id);
    this.loadProjectMeta(this.project_id);
    this.loadAllKeys(this.project_id);
  },
  methods: {
    async loadProjectMeta(project_id) {
      var project_response = await Projects.get(project_id);
      if (project_response.status === 200) {
        if (Array.isArray(project_response.body) && project_response.body.length > 0) {
          this.p_name = project_response.body[0].name;
        } else if (project_response.body && project_response.body.name) {
          this.p_name = project_response.body.name;
        }
      }
    },
    back() {
      this.$router.replace("/project/" + this.project_id);
    },
    async loadAllKeys() {
      var response = await ThirdPartyKeys.getAllKeys(this.project_id);
      if (response.status === 200) {
        this.keys = response.body === undefined ? [] : response.body;
        
        //Clear all keys by default
        this.available_services.forEach(function(key) {
            this.$set(
              this.available_services[this.getPosition(key.service)],
              "api_key",
              ""
            );
        }.bind(this));

        this.keys.forEach(
          function (key) {
            this.$set(
              this.available_services[this.getPosition(key.service)],
              "api_key",
              key.api_key
            );
          }.bind(this)
        );
        this.l_keys = true;
      } else {
        Notifications.show(response.message);
      }
    },
    getPosition(service) {
      var c_index = 0;
      this.available_services.forEach(
        function (available_service, index) {
          if (available_service.value == service) {
            c_index = index;
          }
        }.bind(this)
      );
      return c_index;
    },
    getKeyFromLocal(service_value) {
      var key = "";
      this.available_services.forEach(function (available_service) {
        if (available_service.value === service_value) {
          key = available_service.api_key;
        }
      });
      return key;
    },
    async saveAPIKey(event) {
      event.preventDefault();
      var service = this.available_services[this.nav_service].value;
      var response = await ThirdPartyKeys.assignKeyToProject(
        this.project_id,
        service,
        this.getKeyFromLocal(service)
      );

      if (response.status === 200) {
        Notifications.show("The api key has been successfully saved.");
      } else {
        Notifications.show(response.message);
      }
    },
  },
};
</script>

<style>
</style>